module.exports = "/_next/static/images/9c72b5931602a2d9a7250f31803835cd-kit-photos.png";